import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const MURutinMeny: IRutinInfo[] = [
  rutinInfos.rtnMusikstycke,
  rutinInfos.rtnForfattare,
  rutinInfos.rtnNotarkiv,
  rutinInfos.rtnNoter,
  rutinInfos.rtnFramforanden,
  rutinInfos.rtnExportXML,
];

export default MURutinMeny;
